<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="add" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      :allBtnWidth="allBtnWidth" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template slot="isdisplay" slot-scope="params">
        <MySwitch :data="params.params" :disabled="canNotHide.includes(params.params.id)" :activeValue="`1`"
          :inactiveValue="`2`" @onToggle="toggleDisplay"></MySwitch>
      </template>
    </Table>

    <FormDialog ref="dialog" :title="title" :width="'548px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import systermMixin from "../mixin";

export default {
  mixins: [tableMixin, systermMixin],
  data() {
    return {
      baseUrl: 'gasstationconfigure',
      breadcrumb: [
        { name: "系统设置" },
        { name: "油气站配置" },
      ],
      formCtrl: [
        {
          label: "油气站名称",
          keyName: "gasname",
          placeholder: "请填写油气站名称",
          type: "text",
        },
      ],
      cols: [
        { keyName: "gasname", label: "油气站名称", minwidth: 120 },
        { keyName: "nickname", label: "创建人", minwidth: 120 },
        { keyName: "sort", label: "排序", minwidth: 120 },
        { keyName: "is_display", label: "是否显示", slot: 'isdisplay', minwidth: 120 },
        { keyName: "created_at", label: "添加时间", minwidth: 120 },
      ],
      title: '添加油气站',
      mform: {},
      mrules: {
        gasname: [
          {
            required: true,
            message: '请填写油气站名称',
            trigger: 'blur',
          }
        ],
      },
      mformCtrl: [
        {
          label: "油气站名称",
          keyName: "gasname",
          err: "请填写油气站名称",
          type: "text",
        },
        {
          label: "排序",
          keyName: "sort",
          err: "请填写排序",
          type: "number",
          tips: "数字越小排序越靠前",
        },
        {
          label: "是否显示",
          keyName: "is_display",
          type: "radio",
          options: [
            { label: '是', value: 1 },
            { label: '否', value: 2 },
          ],
        },
      ],
      canNotHide: [1, 2],
      canNotEdit: [1, 2],
    };
  },
  methods: {
    tableDataHandler({ count, data }) {
      this.total = count
      if (data && data.length) {
        this.tableData = data.map(v => {
          const { created_at, ...obj } = v
          let time = created_at
          if (typeof created_at === 'string' && created_at.includes(' ')) {
            const arr = created_at.split(' ')
            time = arr[0];
          }
          obj['created_at'] = time
          obj.open = v.is_display + ''
          if (this.canNotEdit.includes(obj.id)) {
            obj.DISABLED = true
            obj.nickname = '-'
            obj.created_at = '-'
          }
          return obj
        })
      }
      // console.log(this.tableData)
    },
    add() {
      delete this.mform.id
      this.mform = { gasname: undefined, is_display: 1, }
      this.title = this.title.replace('修改', '添加')
      this.showDialog()
    },
    getItem({ id, gasname, is_display, sort }) {
      this.mform = { ...this.mform, id, gasname, is_display, sort }
      this.title = this.title.replace('添加', '修改')
    },
    toggleDisplay({ id, is_display, gasname }) {
      // console.log(id)
      let display = (is_display === 1 ? 2 : 1)
      let url = `${this.baseUrl}/${this.modalSubmitUrl}`;
      const params = {
        userid: this.user.id,
        id,
        gasname,
        is_display: display
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '修改成功!',
          });
          this.getList(true)
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
          // 禁止隐藏，并刷新
          this.getList()
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-dialog {

  .el-form {
    padding-right: 0 !important;

    .el-input {
      width: 230px;
    }
  }

  .btns .mians {
    text-align: center;
  }
}
</style>
